import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Spin } from "antd";
import Header from "./Hearder/Header";
// import { Dash, cp1, LineDetails } from "../data/dash";

// import axios from "../../utils/BasicAuthAPI";
import { deepEqualLineDashValues } from "../../utils/CustomFunc";
import { LoadingOutlined } from "@ant-design/icons";
import IntervalCounter from "./IntervalCounter";
import SessionError from "../../components/ApiErrorComp/SessionError";
import ApiErrorComp from "../../components/ApiErrorComp/ApiErrorComp";
import liracrypt from "../../components/Liracrypt/liracrypt";
import LineDashAndroid from "./LineDashAndroid";

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
class LoadComponent extends React.Component {
  state = {
    settings: null,
    settingValues: null,
    lineDetails: null,
    compliance: null,
    loaded: false,
    loginError: false,
  };

  getCounterProjValue = (counter) => {
    let projValue = "all";
    if (counter % 12 === 0) {
      projValue = "freq_60";
    } else if (counter % 6 === 0) {
      projValue = "freq_30";
    } else if (counter % 3 === 0) {
      projValue = "freq_15";
    }
    return projValue;
  };

  fetchSettingValues = (counter) => {
    if (!this.state.loginError) {
      
      liracrypt
        .get("/linedash/linedashvariabledata", {
          lid: this.props.selectedLid,
          proj: "all",
        })
        .then(({ data }) => {
          if (this.state.settingValues) {
            // if (!deepEqualLineDashValues(this.state.settingValues, data.data)) {
            

            // localStorage.setItem(
            //   "temp_data",
            //   JSON.stringify({
            //     target: data.data["lD_ShiftPerf_Tgt"],
            //     actual: data.data["lD_ShiftPerf_Actual"],
            //     diff: data.data["lD_ShiftPerf_Diff"],
            //     rank: data.data["lD_LineRank_Main"],
            //   })
            // );

            localStorage.setItem("target", data.data["lD_ShiftPerf_Tgt"]);
            localStorage.setItem("actual", data.data["lD_ShiftPerf_Actual"]);
            localStorage.setItem("diff", data.data["lD_ShiftPerf_Diff"]);
            localStorage.setItem("rank", data.data["lD_LineRank_Main"]);

            localStorage.setItem("MainGauge", data.data["lD_MainGauge"]);
            localStorage.setItem("MicroGauge1", data.data["lD_MicroGauge_01"]);
            localStorage.setItem("MicroGauge2", data.data["lD_MicroGauge_02"]);
            localStorage.setItem("MicroGauge3", data.data["lD_MicroGauge_03"]);
            localStorage.setItem("MicroGauge4", data.data["lD_MicroGauge_04"]);
            localStorage.setItem("MicroGauge5", data.data["lD_MicroGauge_05"]);
            localStorage.setItem("MicroGauge6", data.data["lD_MicroGauge_06"]);

            localStorage.setItem("DataBlock1", data.data["lD_DataBlock_01"]);
            localStorage.setItem("DataBlock2", data.data["lD_DataBlock_02"]);
            localStorage.setItem("DataBlock3", data.data["lD_DataBlock_03"]);
            localStorage.setItem("DataBlock4", data.data["lD_DataBlock_04"]);

            localStorage.setItem("text1", data.data["lD_PartDet_pno"]);
            localStorage.setItem("text2", data.data["lD_PartDet_Pname"]);
            localStorage.setItem("text3", data.data["lD_PartDet_Cust"]);

            localStorage.setItem("Date", new Date());
            const updatedValues = { ...this.state.settingValues, ...data.data };
            this.setState({ ...this.state, ...updatedValues });
          }
        })
        .catch(function (error) {
          console.log("Error****:", error);
          if (error.response !== undefined) {
            if (error.response.status !== 401) {
              ApiErrorComp(error.response.status);
            } else {
              this.setState({ ...this.state, loginError: true });
            }
          }
        });
    }
  };

  componentDidMount() {
    localStorage.removeItem("machine");
    localStorage.removeItem("tool");
    localStorage.removeItem("bom");

    localStorage.removeItem("target");
    localStorage.removeItem("actual");
    localStorage.removeItem("diff");

    this.fetchSettingValues = this.fetchSettingValues.bind(this);

    Promise.all([
      liracrypt.get("/linedash/linedashuiconfig/tabview", {}),
      liracrypt.get("/linedash/linedashvariabledata", {
        lid: this.props.selectedLid,
        proj: "all",
      }),
      liracrypt.get("/linedash/linedashfixeddata", {
        lid: this.props.selectedLid,
      }),
      liracrypt.get("/linedash/linedashvariabledata", {
        lid: this.props.selectedLid,
        proj: "compliance",
      }),
    ]).then(([lineDashLoad, lineDashValues, lineDetails, compliance]) => {
      this.setState({
        ...this.state,
        settings: lineDashLoad.data.data,
        settingValues: lineDashValues.data.data,
        lineDetails: lineDetails.data.config,
        compliance: compliance.data.data["compliance"],
        loaded: true,
      });
    });
  }

  render() {
    return (
      <>
        <SessionError visible={this.state.loginError} />
        <React.Fragment>
          {this.state.settings !== null &&
          this.state.settingValues !== null &&
          this.state.loaded === true ? (
            <div
              className="dash"
              style={{
                // backgroundColor: this.state.settings.ld_main[
                //   "background-color"
                // ],
                backgroundColor: "rgb(29, 29, 29)",
                height: "100vh",
                overflow: "hidden",
                position: "fixed",
                width: "100%",
              }}
            >
              <div>
                <Header
                  settings={this.state.settings}
                  settingValues={{
                    ...this.state.settingValues,
                    ld_PageTitle: this.state.lineDetails["ld_PageTitle"],
                  }}
                />
                <Row gutter={24} justify="center">
                  <Col style={{ minHeight: "100%" }}>
                    <LineDashAndroid
                      settings={this.state.settings}
                      settingValues={{
                        ...this.state.settingValues,
                        ...this.state.lineDetails,
                      }}
                      compliance={this.state.compliance}
                      selectedLid={this.props.selectedLid}
                    />
                  </Col>
                </Row>
              </div>
              {/* <IntervalCounter callbackHandler={this.fetchSettingValues} /> */}
              <IntervalCounter
                callbackHandler={this.fetchSettingValues}
                interval={30000}
                projValue={"freq_15"}
              />
            </div>
          ) : (
            <div className="Loading">
              <Spin indicator={antIcon} />
            </div>
          )}
        </React.Fragment>
      </>
    );
  }
}

export default LoadComponent;
